const list = {
  MuiListItem: {
    styleOverrides: {
      root: {},
    },
  },

  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: 0,
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: '14px',
        fontWeight: 400,
      },
    },
  },
};
export default list;
